import React from "react";
import { Tooltip } from "@design-system/Tooltip/Tooltip";
import { FinancialConnection } from "@common/types/financialConnection";
import { DisconnectedConnectionMessage } from "@components/financialConnection/DisconnectedConnectionMessage";
import { AlertIcon } from "@icons";
import {
    ConnectionButtonSize,
    ConnectionButtonVariant,
} from "@components/financialConnection/ConnectionActionButton";
import { FixFinancialConnection } from "./FixFinancialConnection";

interface Props {
    connection: FinancialConnection;
    triggerContent?: React.ReactNode;
    triggerVariant?: ConnectionButtonVariant;
    triggerClassName?: string;
    triggerSize?: ConnectionButtonSize;
    triggerLeftIcon?: React.ReactNode;
    triggerTooltip?: React.ReactNode;
    onFixed?: () => void;
}

export const BrokenFinancialConnectionLink: React.FC<Props> = ({
    connection,
    triggerContent = "Fix connection",
    triggerVariant = "secondary",
    triggerClassName = "broken-connection-link danger",
    triggerSize = "sm",
    triggerLeftIcon = <AlertIcon className="icon-color-red-500" />,
    triggerTooltip,
    onFixed,
}) => {
    const fixTrigger = (
        <FixFinancialConnection
            connection={connection}
            onFixed={onFixed}
            variant={triggerVariant}
            className={triggerClassName}
            size={triggerSize}
            leftIcon={triggerLeftIcon}
            tooltip={triggerTooltip}
        >
            {triggerContent}
        </FixFinancialConnection>
    );

    if (triggerVariant === "menuItem") {
        return fixTrigger;
    }

    return (
        <Tooltip
            content={
                <>
                    <div className="mb-2">
                        <DisconnectedConnectionMessage
                            connection={connection}
                        />
                    </div>
                    Select to fix it.
                </>
            }
        >
            <span>{fixTrigger}</span>
        </Tooltip>
    );
};
